import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { API_PRECOG_URL_V1 } from "../../../config"; 

export const precogAccountRegistryConstants = {
  GET_ACCOUNTING_REGISTRY_DATA_START: "GET_ACCOUNTING_REGISTRY_DATA_START",
  GET_ACCOUNTING_REGISTRY_DATA_SUCCESS: "GET_ACCOUNTING_REGISTRY_DATA_SUCCESS",
  GET_ACCOUNTING_REGISTRY_DATA_ERROR: "GET_ACCOUNTING_REGISTRY_DATA_ERROR"
};

export function getAccountRegistryData(accountCode) {
  return (dispatch, getState) => {
    // TODO temporary code
    /*
    dispatch({
      type: precogAccountRegistryConstants.GET_ACCOUNTING_REGISTRY_DATA_START
    });
    return new Promise((resolve, reject) => {
      resolve({
        irpefOrIres: "50%",
        fiscalIrap: "50%",
        civilisticIrap: "50%",
        nonDeductibility: "50%",
        ivaDeduction: "Cessione di beni ammortizzabili",
        subjectToWitholdingTax: "NO",
        fixedAssetsAccount: "NO",
        subjectToSuspension: "Professionista e impresa"
      });
    });
    */

    // TODO Update code below when API is ready
    
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    let url = `${API_PRECOG_URL_V1}/accounting/accounts/account?itemId=${itemId}&managerId=${managerId}&accountCode=${accountCode}`;

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogAccountRegistryConstants.GET_ACCOUNTING_REGISTRY_DATA_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogAccountRegistryConstants.GET_ACCOUNTING_REGISTRY_DATA_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: precogAccountRegistryConstants.GET_ACCOUNTING_REGISTRY_DATA_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogAccountRegistryConstants.GET_ACCOUNTING_REGISTRY_DATA_ERROR,
            error: response
          });
          reject();
        });
    });
    
  };
}
